import React from 'react';
import Brands from './Brands';
const BrandsS = ({ color, ...props }) => (React.createElement(Brands, Object.assign({ color: color, size: 24 }, props)));
BrandsS.displayName = 'BrandsS'; // Fix for tsc
export default BrandsS;
//# sourceMappingURL=BrandsS.js.map